var collapsible_list_component_default = {
  "ltr": "_5B2mf",
  "rtl": "RNlp2",
  "iconContainer": "VikeW",
  "icon": "thv1i",
  "isExpanded": "w6wKf",
  "listDimensions": "kGJ1G"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
